import React from 'react'
import { UserForAvatar } from '../../../types/User'

export interface AvatarProps {
    url?: string
    user?: UserForAvatar
    size?: 'small' | 'medium'
}

export const Avatar = ({ url, user, size = 'medium' }: AvatarProps) => {
    const wrapperSizeClasses = size === 'small' ? 'w-6 h-6' : 'w-6 h-6 density-lg:w-8 density-lg:h-8'
    const textSizeClasses = size === 'small' ? 'text-xxs' : 'text-xs density-lg:text-lg'

    return (
        <div className={`inline-flex rounded-full overflow-hidden bg-accent-200 ${wrapperSizeClasses}`}>
            {url && <img src={url} className="object-cover" />}
            {!url && user && user.firstName && user.lastName && (
                <div
                    className={`uppercase inline-flex items-center justify-center w-full h-full text-text-interactive ${textSizeClasses}`}
                >
                    {user.firstName.charAt(0)}
                    {user.lastName.charAt(0)}
                </div>
            )}
        </div>
    )
}
